module.exports = __webpack_public_path__ + "static/media/reactjs.9675df2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/reactjs.png
// module id = 47
// module chunks = 0